import classes from './_grid_two.module.scss';

export default class GridTwo extends HTMLElement {
  connectedCallback() {
    this.classList.add(classes['l-grid-two']);
  }
}; 
